(() => {
  const locale = document.documentElement.lang.toLowerCase();
  if (locale === 'en' || locale.startsWith('en-')) return;

  const ignoredElements = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'CODE', 'PRE']);
  const translatedAttributes = ['aria-label', 'title', 'placeholder', 'data-label', 'data-title'];
  let dictionary;

  function getDictionary() {
    if (dictionary) return dictionary;
    const data = document.getElementById('TorrasHardcodedI18n');
    if (!data) return null;
    try {
      dictionary = JSON.parse(data.textContent);
    } catch (error) {
      dictionary = {};
    }
    return dictionary;
  }

  function translateValue(value) {
    const translations = getDictionary();
    if (!translations) return value;
    const trimmed = value.trim();
    const translated = translations[trimmed];
    if (!translated || translated === trimmed) return value;
    return value.replace(trimmed, translated);
  }

  function translateElement(element) {
    if (ignoredElements.has(element.tagName) || element.closest('[data-i18n-skip]')) return;
    for (const attribute of translatedAttributes) {
      if (!element.hasAttribute(attribute)) continue;
      const value = element.getAttribute(attribute);
      const translated = translateValue(value);
      if (translated !== value) element.setAttribute(attribute, translated);
    }
  }

  function translateTree(root) {
    const translations = getDictionary();
    if (!translations) return;
    if (root.nodeType === Node.TEXT_NODE) {
      const parent = root.parentElement;
      if (!parent || ignoredElements.has(parent.tagName) || parent.closest('[data-i18n-skip]')) return;
      const translated = translateValue(root.nodeValue);
      if (translated !== root.nodeValue) root.nodeValue = translated;
      return;
    }
    if (!(root instanceof Element)) return;
    translateElement(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const parent = node.parentElement;
        if (parent && !ignoredElements.has(parent.tagName) && !parent.closest('[data-i18n-skip]')) {
          const translated = translateValue(node.nodeValue);
          if (translated !== node.nodeValue) node.nodeValue = translated;
        }
      } else {
        translateElement(node);
      }
      node = walker.nextNode();
    }
  }

  function start() {
    translateTree(document.body);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') translateTree(mutation.target);
        mutation.addedNodes.forEach(translateTree);
      }
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
